import {
  PackageSocialCommitment,
  ProjectSocialCommitment,
  SocialCommitmentLineItem,
  SocialCommitmentTypeHour,
  SocialCommitmentTypeSpend,
  TargetUnit,
} from "@interfaces/commitment";

export const decodeProjectSocialCommitment = (
  socialCommitment: ProjectSocialCommitment
): SocialCommitmentLineItem => {
  return {
    id: socialCommitment.project_social_commitment_id,
    targetValue: socialCommitment.target_value,
    targetDescription: socialCommitment.target_description,
    targetName: decodeTargetName(socialCommitment.target_type),
    targetUnit: decodeTargetUnit(socialCommitment.target_type),
    created: new Date(socialCommitment.created),
  };
};

export const encodeProjectSocialCommitment = (
  socialCommitment: SocialCommitmentLineItem
): ProjectSocialCommitment => {
  return {
    project_social_commitment_id: socialCommitment.id,
    target_value: socialCommitment.targetValue,
    target_description: socialCommitment.targetDescription,
    created: socialCommitment.created,
    target_type: encodeTargetName(socialCommitment.targetName),
  };
};

export const decodePackageSocialCommitment = (
  socialCommitment: PackageSocialCommitment
): SocialCommitmentLineItem => {
  return {
    id: socialCommitment.package_social_commitment_id,
    targetValue: socialCommitment.target_value,
    targetDescription: socialCommitment.target_description,
    targetName: decodeTargetName(socialCommitment.target_type),
    targetUnit: decodeTargetUnit(socialCommitment.target_type),
    created: new Date(socialCommitment.created),
  };
};

export const encodePackageSocialCommitment = (
  socialCommitment: SocialCommitmentLineItem
): PackageSocialCommitment => {
  return {
    package_social_commitment_id: socialCommitment.id,
    target_value: socialCommitment.targetValue,
    created: socialCommitment.created,
    target_type: encodeTargetName(socialCommitment.targetName),
  };
};

export const decodeTargetUnit = (targetType: string): TargetUnit => {
  switch (targetType) {
    default:
    case "social-commitment-type_default-spend":
    case "social-commitment-type_local-content":
    case "social-commitment-type_social-disability-enterprise-spend":
    case "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend":
      return TargetUnit.Spend;
    case "social-commitment-type_default-hours":
    case "social-commitment-type_local-jobs-first":
    case "social-commitment-mpsg-hours-requirment":
    case "social-commitment-type_opportunities-for-disadvantaged-victorians":
    case "social-commitment-type_female-participation":
    case "social-commitment-type_aboriginal-torres-strait-island-participation":
      return TargetUnit.Hour;
  }
};

export const decodeTargetName = (
  targetName: string
): SocialCommitmentTypeSpend | SocialCommitmentTypeHour => {
  switch (targetName) {
    default:
    case "social-commitment-type_default-spend":
      return SocialCommitmentTypeSpend.DefaultSpend;
    case "social-commitment-type_local-content":
      return SocialCommitmentTypeSpend.LocalContent;
    case "social-commitment-type_social-disability-enterprise-spend":
      return SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend;
    case "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend":
      return SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend;
    case "social-commitment-type_default-hours":
      return SocialCommitmentTypeHour.DefaultHour;
    case "social-commitment-type_local-jobs-first":
      return SocialCommitmentTypeHour.LocalJobsFirst;
    case "social-commitment-mpsg-hours-requirment":
      return SocialCommitmentTypeHour.MPSGHoursRequirement;
    case "social-commitment-type_opportunities-for-disadvantaged-victorians":
      return SocialCommitmentTypeHour.OpportunitiesForDisadvantagedVictorians;
    case "social-commitment-type_female-participation":
      return SocialCommitmentTypeHour.FemaleParticipation;
    case "social-commitment-type_aboriginal-torres-strait-island-participation":
      return SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation;
  }
};

const encodeTargetName = (
  targetType: SocialCommitmentTypeSpend | SocialCommitmentTypeHour
): string => {
  switch (targetType) {
    case SocialCommitmentTypeHour.DefaultHour:
      return "social-commitment-type_default-hours";
    case SocialCommitmentTypeHour.LocalJobsFirst:
      return "social-commitment-type_local-jobs-first";
    case SocialCommitmentTypeHour.MPSGHoursRequirement:
      return "social-commitment-mpsg-hours-requirment";
    case SocialCommitmentTypeHour.OpportunitiesForDisadvantagedVictorians:
      return "social-commitment-type_opportunities-for-disadvantaged-victorians";
    case SocialCommitmentTypeHour.FemaleParticipation:
      return "social-commitment-type_female-participation";
    case SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation:
      return "social-commitment-type_aboriginal-torres-strait-island-participation";
    case SocialCommitmentTypeSpend.DefaultSpend:
      return "social-commitment-type_default-spend";
    case SocialCommitmentTypeSpend.LocalContent:
      return "social-commitment-type_local-content";
    case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
      return "social-commitment-type_social-disability-enterprise-spend";
    case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
      return "social-commitment-type_aboriginal-torres-strait-island-buseinss-spend";
  }
};
